// removed by extract-text-webpack-plugin
module.exports = {"NavigationItems":"NavigationItems__NavigationItems___yd_d","ShowDrawerNavigation":"NavigationItems__ShowDrawerNavigation__31NwD"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/NavigationItems/NavigationItems.css
// module id = 89
// module chunks = 0